<div class="container">
  <app-breadcrumbs
    [segments]="[{ label: breadcrumbLabel , routerLink: '/risultati' }]"
  ></app-breadcrumbs>
</div>

<div class="container">
  <div class="row">
    <app-search-input
      layout="resultspage"
      [suggestion]="true"
      [data]="query"
      (queryEvent)="search($event)"
    ></app-search-input>
  </div>
</div>

<div class="container">
  <!-- BARRA RISULTATI START -->
  <div class="text-primary ps-4 filters-div padding-1" aria-live="polite" role="status">
    <h3
      *ngIf="query"
      style="color: var(--primary-color)"
      i18n="messaggio risultati ricerca|Header risultati ricerca @@result-page.result-bar.result-text"
    >
      {resLen, plural, =0 {Nessun risultato trovato per {{ query }}} =1 {1
      Risultato trovato per {{ query }}} other {{{resLen}} Risultati trovati per
      "{{ query }}"}}
    </h3>
    <h3
      *ngIf="!query"
      style="color: var(--primary-color)"
      class="m-0"
      i18n="messaggio risultati ricerca senza query|Header risultati ricerca @@result-page.result-bar.no-result-text"
    >
      {resLen, plural, =0 {Nessun risultato trovato} =1 {1 Risultato trovato }
      other {{{resLen}} Risultati trovati }}
    </h3>

    <p *ngIf="error" class="m-0" style="font-size: 1rem">
      <span
        style="color: #f83e5a"
        i18n="messaggio correzione ricerca|Header risultati ricerca @@result-page.result-bar.correction-result-text"
      >
        CERCAVI INVECE
      </span>
      <span
        style="color: #f83e5a; cursor: pointer"
        (click)="search({queryString: error, selectedFromAutocomplete: false},undefined,true)"
      >
        {{ error | uppercase }}
      </span>
    </p>
  </div>
  <!-- BARRA RISULTATI END -->

  <div class="row pt-4">
    <div class="col-12 col-xl-4">
      <app-filtri
        [query]="query"
        [urlFilter]="filters"
        (emitSearch)="filteredSearch($event)"
      ></app-filtri>
    </div>

    <div class="col-12 col-xl-8">
      <div
        infinite-scroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="1000"
        (scrolled)="scrollSearch()"
      >
        <div *ngIf="!data" class="row">
          <div class="custom-card col-12">
            <div
              class="custom-card-body"
              i18n="messaggio nessun risultato|Risultato ricerca @@result-page.result-bar.loading-text"
            >
              Caricamento in corso
            </div>
          </div>
        </div>

        <div>
          <ng-template [ngIf]="data" [ngIfElse]="noResults">
            <ng-container *ngFor="let fd of data">
              <app-forma-dosaggio
                (navigate)="dettaglio(fd.id)"
                [formaDosaggio]="fd"
                [page]="page"
                [totalElements]="resLen"
              ></app-forma-dosaggio>
            </ng-container>
          </ng-template>

          <ng-template #noResults>
            <div class="row">
              <div class="custom-card col-12">
                <div
                  class="custom-card-body"
                  i18n="messaggio nessun risultato|Risultato ricerca @@result-page.result-bar.no-result"
                >
                  Non ci sono risultati
                </div>
              </div>
            </div>
          </ng-template>

          <!-- SPINNER LOAD START -->
          <div class="row" *ngIf="caricamento">
            <div class="custom-card-result col-12">
              <div class="custom-card-body text-center">
                <app-spinner></app-spinner>
              </div>
            </div>
          </div>
          <!-- SPINNER LOAD END -->
        </div>
      </div>
    </div>
  </div>
</div>
